import React from 'react';

import {BehaviorEventRow} from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/event-row';
import {
  DraggableBehavior,
  useBehaviorsList,
} from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/behaviors-list';
import {useTranslation} from 'common/i18n/hooks';
import {getEmptyEventMetricEntryBehavior} from 'iron/common/query-builder/query-entry-section/row-types/new-metric-entry/utils';

import type {RowProps} from '../catalog';
import styles from './index.module.styl';

/**
 * Renders a behavior definition for specifying multiple event conditions a user can be matched
 * on, this mimics the functionality of custom events.
 */
export function SimpleBehaviorDefinition(props: RowProps & {queryBlockConfig?: Obj}) {
  const {t} = useTranslation();

  const {behaviors, handleAddBehavior, handleUpdateBehavior, handleDeleteBehavior, handleDuplicateBehavior} =
    useBehaviorsList(props.entry, props.updateEntry);

  const hasMultipleEvents = (behaviors ?? []).length > 1;

  return (
    <div className={styles.simpleBehavior}>
      {behaviors.map((subBehavior, index) => {
        return (
          <DraggableBehavior
            {...props}
            // @todo(metrics) Figure out a way to uniquely identify each behavior in a metric
            // key={index}
            showAllEvents={props.queryBlockConfig?.showAllEvents ?? true}
            index={index}
            metricIndex={props.index}
            parentMetricIndex={props.parentMetricIndex}
            enableCohortFilters
            isLast={index === behaviors.length - 1}
            behavior={subBehavior}
            label={t(`query-builder.select-event`)}
            onDelete={hasMultipleEvents ? () => handleDeleteBehavior(index) : null}
            onDuplicate={() => handleDuplicateBehavior(index)}
            onSelect={(behavior) => handleUpdateBehavior(index, behavior)}
            suffixLabel={hasMultipleEvents && index !== behaviors.length - 1 ? ` or` : null}
          />
        );
      })}

      {props.isValidClause && (
        <BehaviorEventRow
          {...props}
          showAllEvents={props.queryBlockConfig?.showAllEvents ?? true}
          index={-1}
          behavior={{...getEmptyEventMetricEntryBehavior(), name: t(`query-builder.metrics.add-event`)}}
          hideControls
          isSecondaryRow
          onSelect={(behavior) => handleAddBehavior(behavior)}
          rowIcon='behavior-event-add-step'
        />
      )}
    </div>
  );
}
